// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qyTWV","image":"Header_image__oHzff","name":"Header_name__2FYYK","info":"Header_info__21Llp","infoRow":"Header_infoRow__LnQU3"};